import { Form } from "antd";
import { Moment } from "moment";
import { Button } from "react-bootstrap";
import { getEnv } from "../../../../AppConfigs";
import { FontFa } from "../../../../components";
import { CreateNotification } from "../../../../components/notifier";
import ViagsModalForm from "../../../../components/viags-modal-form/viags-modal-form";
import { documentStatus } from "../../../../constants";
import PERMISSIONS from "../../../../constants/permissions";
import { DateHelper } from "../../../../helper";
import { getDay, setUtcTime } from "../../../../helper/dateTimeHelper";
import { useUser } from "../../../../hook";
import { useSearchParams } from "../../../../hook/use-search-params";
import { Employee } from "../../../../services/department-viags/employee-viags.service";
import { StatisticsEmployeeService } from "../../../../services/department-viags/statistics-employee.service";
import { DocumentService } from "../../../../services/document/document.service";
import { FileService } from "../../../../services/file/file.service";
import { MailService } from "../../../../services/mail/mail.service";
import { useCreateNotify } from "../../../notify/hooks/use-create-notify";
import { useUpdateDocumentInfo } from "../../hooks";
import { MailDocumentType, mailPublishMultipleFile, PublishMultipleFileMailProps } from "../../utils/mailTemplate";
import { PublishMultipleFileFormItem } from "./publish-multiple-file-form-item";

const publicSPListId = getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID");
const publicInfoSPListId = getEnv("REACT_APP_WORKING_DOCS_PUBLISH_INF_LIST_ID");

type ViewEmployeeType = Employee & { isView: boolean; isEdit: boolean; depList: any[] };

type FormItemType = {
  documentData: any[];
  employeeData: ViewEmployeeType[];
  effectiveDate: [Moment, Moment];
  subInfo: string;
  docNotes: string;
};

type DocumentType = {
  docCode: string;
  Title: string;
  docPublishViewVersion: any;
  docEditionVersion: any;
  startDate: any;
  url: string;
};

export const PublishMultipleFileModal = ({ documentData, disabled, getDocumentData }: any) => {
  const [form] = Form.useForm();
  const { searchParams, replaceSearchParams } = useSearchParams();
  const { mutate } = useUpdateDocumentInfo();
  const { name, email } = useUser();
  // const { name, id: userId, email, checkCurrentUser } = useUser();
  const { addNotify } = useCreateNotify();
  const baseUrl = getEnv("REACT_APP_DOMAIN_URL");

  const handleFinish = async (values: FormItemType) => {
    const { documentData, subInfo, docNotes, employeeData } = values;
    const filteredEmployeeData = employeeData.filter((e) => e.isView || e.isEdit);

    const filteredDocument: any[] = documentData.filter((e) => !e.docCode);
    filteredDocument.forEach((e) => {
      CreateNotification({
        title: "Thông báo",
        body: `Vui lòng nhập thông tin mã tài liệu cho tài liệu ${e.Title}!`,
        icon: "/icons/warning.png",
      });
    });

    if (filteredDocument.length > 0) return;

    const mappedEmployeeData = filteredEmployeeData.map((e) => ({
      Claims: `i:0#.f|membership|${e.employeeEmail}`,
      Id: e.employeeCode,
      displayName: e.employeeName,
      email: e.employeeEmail,
      jobTitle: "",
      department: e.departmentName,
      departmentCode: e.departmentCode,
      departmentId: e.departmentId,
      pDeptCode: e.depList?.at(1)?.name_VN,
      isView: e.isView,
      isEdit: e.isEdit,
    }));

    const employees = JSON.stringify(mappedEmployeeData);
    const { id, value, label } = documentStatus.publish;
    // const [startDate, endDate] = effectiveDate;

    const docList: DocumentType[] = [];

    for (const docData of documentData) {
      const {
        Title,
        docEditionVersion,
        docPublishViewVersion,
        docCode,
        docOrder,
        Tags,
        listItemId,
        nameWithoutExt,
        docAreas,
        parentSubFolderPath,
        id: docId,
        docType,
      } = docData;

      const uploadedFile = {
        content: "",
        size: 0,
        name: `${nameWithoutExt}.pdf`,
      };

      const commonFields = {
        subInfo,
        docNotes,
        docStatusId: id,
        docStatusValue: value,
        docStatus: label,
        docPublicVersion: null,
      };

      const { id: fileDriveId } = await FileService.createFileWithFolderPath(
        uploadedFile,
        parentSubFolderPath,
        publicSPListId,
      );

      const statisticEmployee = employeeData.map((e) => ({
        departmentId: +e.departmentId!,
        employeeCode: e.employeeCode,
        employeeEmail: e.employeeEmail,
        departmentCode: e.departmentCode,
        departmentName: e.departmentName,
      }));

      const publicFileInfo = await FileService.getFile(fileDriveId, publicSPListId);

      const documentUpdateFields = {
        ...commonFields,
        Title,
        docEditionVersion,
        docPublishViewVersion,
      };

      await FileService.updateFileInfo(listItemId, documentUpdateFields);

      const documentInfo = await DocumentService.getDocumentInfo(listItemId);

      const newDoc: DocumentType = {
        docCode: docCode,
        Title: Title,
        docEditionVersion: docEditionVersion,
        docPublishViewVersion: docPublishViewVersion,
        startDate: DateHelper.formatDateToString(documentInfo?.effectiveFrom),
        url: `${baseUrl}/document/detail/${listItemId}?fileId=${id}&action=info&status=publish&index=2`,
      };

      docList.push(newDoc);

      const documentInfoUpdateFields = {
        ...commonFields,
        fileAssignedTo: employees,
        docLinks: JSON.stringify([]),
        effectiveFrom: documentInfo?.effectiveFrom,
        effectiveTo: documentInfo?.effectiveTo,
      };

      if (documentInfo?.id) mutate({ id: documentInfo?.id + "", body: documentInfoUpdateFields });

      const publishDocumentUpdateFields = {
        docTypeLookupId: "2",
        docNotes,
        docEditionVersion,
        docPublishViewVersion,
        docCode,
        docOrder,
        docStatusId: id,
        docStatusValue: value,
        docStatus: label,
        Title,
        Tags: JSON.stringify(Tags),
        docWorkingId: +listItemId,
        workingFileId: docId,
        expiredDate: documentInfo?.effectiveTo,
        fileAssignedTo: employees,
      };

      await FileService.updateFileInfoFromDocumentInfo(
        publicFileInfo.listItemId,
        publishDocumentUpdateFields,
        publicSPListId,
      );

      const statisticFields = {
        docId: listItemId && +listItemId,
        docCode: docCode,
        docName: Title,
        docType: docType,
        docStatus: label,
        effectiveFrom: setUtcTime(getDay(documentInfo?.effectiveFrom)),
        effectiveTo: setUtcTime(getDay(documentInfo?.effectiveTo)),
        listIssusedUser: [...statisticEmployee],
      };

      await StatisticsEmployeeService.addPublishDocForUsers(statisticFields);

      const createFileFields = {
        fileId: docId,
        docId: publicFileInfo.listItemId,
        Title,
        docUrl: publicFileInfo.url,
        docTypeLookupId: "2",
        docStatusId: id,
        docStatus: label,
        docStatusValue: value,
        docNotes,
        approvedDate: documentInfo?.effectiveFrom,
        effectiveFrom: documentInfo?.effectiveFrom,
        effectiveTo: documentInfo?.effectiveTo,
        fileAssignedTo: employees,
        docPublicEndUsers: employees,
        docEditors: JSON.stringify([]),
        docPublishViewVersion,
        docEditionVersion,
        docCode,
        docOrder,
        Tags: JSON.stringify(Tags),
        docAreas: JSON.stringify(docAreas),
        IsConvertToPDF: true,
        docWorkingId: listItemId,
        workingFileId: docId,
        fileAttachment: documentInfo?.fileAttachment ? JSON.stringify(documentInfo?.fileAttachment) : null,
      };

      await FileService.createFileDocumentInfo(
        publicFileInfo,
        publicFileInfo.parentId,
        createFileFields,
        publicSPListId,
        publicInfoSPListId,
      );
    }

    CreateNotification({
      title: "Thông báo",
      body: `Ban hành thành công !. Anh chị vui lòng đợi ít phút để có hiệu lực`,
      icon: "/icons/success.png",
    });

    const listSendEmail = employeeData.map((e) => e.employeeEmail);

    console.log(docList);

    sendMail(docList, docNotes, listSendEmail);

    setTimeout(async () => {
      await getDocumentData();
    }, 3000);
    return true;
  };

  const handleClose = () => {
    form.resetFields();
    searchParams.delete("deptCode");
    replaceSearchParams(searchParams);
  };

  const sendMail = (listDocument: MailDocumentType[], message: string, listEmail: string[]) => {
    const sendMailParams: PublishMultipleFileMailProps = {
      listDocument: listDocument,
      message: message ?? "",
      publishDepartment: "",
      userDisplayName: name ?? "",
      userEmail: email ?? "",
    };
    const subject = "TRIỂN KHAI TÀI LIỆU MỚI";
    const content = mailPublishMultipleFile(sendMailParams);
    const fieldsNotify = {
      Title: subject,
      N_x1ed9_idung: content,
      NotifyTo: listEmail.join(";"),
    };
    addNotify(fieldsNotify);
    MailService.sendMailByBotit({ content, subject, toMail: listEmail.join(";") });
    // const mail = MailService.buildMailMesssageForPeople(subject, content, "html", listEmail);
    // MailService.sendMail(mail);
  };

  return (
    <ViagsModalForm
      triggerPermission={PERMISSIONS.DEPLOY_DOCUMENT}
      trigger={
        <Button disabled={disabled} title={"Ban hành nhiều tài liệu"} className="mr-2" variant="outline-primary">
          <FontFa name="faFileExport" size={"lg"} />
        </Button>
      }
      modalProps={{
        title: "Ban hành nhiều tài liệu",
        width: "90vw",
        destroyOnClose: true,
        afterClose: handleClose,
      }}
      form={form}
      labelCol={{ span: 6 }}
      size="large"
      layout="horizontal"
      onFinish={handleFinish}
    >
      <PublishMultipleFileFormItem documentData={documentData} />
    </ViagsModalForm>
  );
};
